// extracted by mini-css-extract-plugin
export default {"life-insurance-policy-value-inputs":"styles_life-insurance-policy-value-inputs__+Z8zY","life-insurance-policy-value-label":"styles_life-insurance-policy-value-label__IkaiE"};